import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'hu',
  months: [
    'január',
    'február',
    'március',
    'április',
    'május',
    'június',
    'július',
    'augusztus',
    'szeptember',
    'október',
    'november',
    'december',
  ],
  monthsShort: ['jan.', 'feb.', 'már.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szep.', 'okt.', 'nov.', 'dec.'],
  weekdays: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
  weekdaysMin: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
  weekdaysShort: ['vas.', 'hét.', 'ke.', 'szer.', 'csüt.', 'pén.', 'szo.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'H:mm',
    lts: 'H:mm:ss',
    L: 'YYYY. MM. DD.',
    LL: 'YYYY. MMMM D.',
    'LL-D': 'YYYY. MMMM',
    'LL-Y': 'MMMM D.',
    LLL: 'YYYY. MMMM D. H:mm',
    'LLL-Y': 'MMMM D. H:mm',
    LLLL: 'YYYY. MMMM D., dddd H:mm',
    'LLLL-Y': 'dddd, MMMM D. H:mm',
    l: 'YYYY. MM. DD.',
    'l-Y': 'M. D.',
    ll: 'YYYY. MMM D.',
    'll-Y': 'MMM D.',
    'll-D': 'YYYY. MMM',
    lll: 'YYYY. MMM D., H:mm',
    'lll-Y': 'MMM D., H:mm',
    llll: 'YYYY. MMM D., ddd, H:mm',
    'llll-Y': 'MMM D., ddd, H:mm',
    'll-Y+w': 'MMM D., ddd',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'YYYY. MMMM D. H:mm ([GMT]Z)',
  },
  meridiem: { am: 'de.', pm: 'du.', AM: 'de.', PM: 'du.' },
  past: {
    y: { one: '%s évvel ezelőtt', other: '%s évvel ezelőtt' },
    M: { one: '%s hónappal ezelőtt', other: '%s hónappal ezelőtt' },
    w: { one: '%s héttel ezelőtt', other: '%s héttel ezelőtt' },
    d: { one: '%s nappal ezelőtt', other: '%s nappal ezelőtt' },
    h: { one: '%s órával ezelőtt', other: '%s órával ezelőtt' },
    m: { one: '%s perccel ezelőtt', other: '%s perccel ezelőtt' },
    s: { one: '%s másodperccel ezelőtt', other: '%s másodperccel ezelőtt' },
  },
  future: {
    y: { one: '%s év múlva', other: '%s év múlva' },
    M: { one: '%s hónap múlva', other: '%s hónap múlva' },
    w: { one: '%s hét múlva', other: '%s hét múlva' },
    d: { one: '%s nap múlva', other: '%s nap múlva' },
    h: { one: '%s óra múlva', other: '%s óra múlva' },
    m: { one: '%s perc múlva', other: '%s perc múlva' },
    s: { one: '%s másodperc múlva', other: '%s másodperc múlva' },
  },
  pastLong: {
    y: { one: '%s évvel ezelőtt', other: '%s évvel ezelőtt' },
    M: { one: '%s hónappal ezelőtt', other: '%s hónappal ezelőtt' },
    w: { one: '%s héttel ezelőtt', other: '%s héttel ezelőtt' },
    d: { one: '%s nappal ezelőtt', other: '%s nappal ezelőtt' },
    h: { one: '%s órával ezelőtt', other: '%s órával ezelőtt' },
    m: { one: '%s perccel ezelőtt', other: '%s perccel ezelőtt' },
    s: { one: '%s másodperccel ezelőtt', other: '%s másodperccel ezelőtt' },
  },
  futureLong: {
    y: { one: '%s év múlva', other: '%s év múlva' },
    M: { one: '%s hónap múlva', other: '%s hónap múlva' },
    w: { one: '%s hét múlva', other: '%s hét múlva' },
    d: { one: '%s nap múlva', other: '%s nap múlva' },
    h: { one: '%s óra múlva', other: '%s óra múlva' },
    m: { one: '%s perc múlva', other: '%s perc múlva' },
    s: { one: '%s másodperc múlva', other: '%s másodperc múlva' },
  },
  abbr: {
    y: { one: '%s év', other: '%s év' },
    M: { one: '%s hó', other: '%s hó' },
    w: { one: '%s h', other: '%s h' },
    d: { one: '%s n', other: '%s n' },
    h: { one: '%s ó', other: '%s ó' },
    m: { one: '%s p', other: '%s p' },
    s: { one: '%s mp', other: '%s mp' },
  },
  full: {
    y: { one: '%s év', other: '%s év' },
    M: { one: '%s hónap', other: '%s hónap' },
    w: { one: '%s hét', other: '%s hét' },
    d: { one: '%s nap', other: '%s nap' },
    h: { one: '%s óra', other: '%s óra' },
    m: { one: '%s perc', other: '%s perc' },
    s: { one: '%s másodperc', other: '%s másodperc' },
  },
  justNow: 'Épp most',
  yesterday: 'Tegnap',
  today: 'Ma',
  tomorrow: 'Holnap',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'YYYY. MMMM D.', end: 'YYYY. MMMM D.' },
    'yl-1': { start: 'MMMM D.', end: 'YYYY. MMMM D.' },
    ml: { start: 'MMMM D.', end: 'MMMM D.' },
    'ml-1': { start: 'YYYY. MMMM D', end: 'D.' },
    dl: { start: 'MMMM D', end: 'D.' },
    y: { start: 'YYYY. MMM D.', end: 'YYYY. MMM D.' },
    'y-1': { start: 'YYYY. MMM D.', end: 'MMM D.' },
    m: { start: 'MMM D.', end: 'MMM D.' },
    'm-1': { start: 'YYYY. MMM D', end: 'D.' },
    d: { start: 'MMM D', end: 'D.' },
    Y: { start: 'YYYY. MMM D., ddd', end: 'YYYY. MMM D., ddd' },
    'Y-1': { start: 'YYYY. MMM D., ddd', end: 'MMM D., ddd' },
    M: { start: 'MMM D., ddd', end: 'MMM D., ddd' },
    D: { start: 'MMM D., ddd', end: 'D., ddd' },
    yt: { start: 'YYYY. MMM D. H:mm', end: 'YYYY. MMM D. H:mm' },
    mt: { start: 'MMM D. H:mm', end: 'MMM D. H:mm' },
    dt: { start: 'MMM D. H:mm', end: 'MMM D. H:mm' },
    t: { start: 'H:mm', end: 'H:mm' },
    'yt+to': { start: 'YYYY. MMM D. H:mm', end: 'YYYY. MMM D. H:mm ([GMT]Z)' },
    'mt+to': { start: 'MMM D. H:mm', end: 'MMM D. H:mm ([GMT]Z)' },
    'dt+to': { start: 'MMM D. H:mm', end: 'MMM D. H:mm ([GMT]Z)' },
    't+to': { start: 'H:mm', end: 'H:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'hu';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'de.' : 'de.';
    } else {
      return isLowerCase ? 'du.' : 'du.';
    }
  },
};
